import type { CSSProperties, HTMLAttributes, Ref } from 'react'

const cx = (...classes: (string | undefined | false | null)[]) => classes.filter(Boolean).join(' ')

interface DivProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>
}

const BodyWrapperBase = ({ ref, className, ...props }: DivProps) => (
  <div
    ref={ref}
    className={cx('flex justify-center w-full min-h-[calc(100vh-100px)]', className)}
    {...props}
  />
)

const BodyWrapperLeft = ({ ref, className, ...props }: DivProps) => (
  <div
    ref={ref}
    className={cx('flex justify-center min-w-[50px] w-[150px]', className)}
    {...props}
  />
)

export const BodyWrapper = Object.assign(BodyWrapperBase, {
  Left: BodyWrapperLeft,
})

export const SectionWrapper = ({ ref, className, ...props }: DivProps) => (
  <div
    ref={ref}
    className={cx('flex flex-wrap gap-5 flex-1 w-full', className)}
    {...props}
  />
)

interface TileProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>
  background?: string
  textColor?: string
  width?: string
  height?: string
}

export const Tile = ({ ref, className, background, textColor, width, height, style, ...props }: TileProps) => (
  <div
    ref={ref}
    className={cx('rounded-[10px] shadow-md p-5 text-lg font-bold text-center flex justify-center items-center flex-grow cursor-pointer hover:opacity-90', className)}
    style={{
      background: background || '#ffffff33',
      color: textColor || '#fff',
      width: width || '200px',
      height: height || '150px',
      ...style,
    }}
    {...props}
  />
)

export const StatsWrapper = ({ ref, className, ...props }: DivProps) => (
  <div
    ref={ref}
    className={cx('mb-10 flex justify-around text-center [&_.stat]:text-white [&_.stat]:text-base [&_.stat_.percentage]:text-2xl [&_.stat_.percentage]:font-bold', className)}
    {...props}
  />
)
